export default __webpack_public_path__ + "static/media/support.d368596c.png";